import Cookies from 'js-cookie';
import type { StateCreator } from 'zustand';
import { COOKIE_NAME } from '@/helpers/cookie';
import type { CommonStoreType, PlayerState } from '../types';

export const usePlayerSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  PlayerState
> = () => ({
  lastSuccessfulPaymentsByCurrency: {},
  lastSuccessfulPaymentsByCurrencyPending: false,
  isAuthenticatedByCookie: Cookies.get(COOKIE_NAME.IS_AUTHENTICATED) === 'true',
});
